import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Tooltip } from './Tooltip'

export function IconButton({ label, children, className = '', ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { label: string; children: ReactNode }) {
  return <Tooltip label={label}><button {...props} type={props.type ?? 'button'} aria-label={label} title={label} className={`ui-icon-button ${className}`}>{children}</button></Tooltip>
}
